import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import AttachmentsModal from './modal';
import Button from 'shared/button';
import FileArchiver from 'components/file_archiver';

import { copyAttachments } from 'bundles/apex/deals/show/store/deal/actions';

export function AttachmentControls({ attachmentsArchivePath, copyAttachments, parentDeal }) {
  const [showModal, setShowModal] = useState(false);

  if (!parentDeal.attachments?.length) {
    return <FileArchiver path={attachmentsArchivePath} />;
  }
  
  return (
    <div className="d-flex flex-row align-items-center">
      <FileArchiver path={attachmentsArchivePath} />
      <Button.Primary
        className="ml-3"
        label="Copy from Property Deal"
        onClick={() => setShowModal(true)}
      />
      <AttachmentsModal
        copyAttachments={copyAttachments}
        parentAttachments={parentDeal.attachments}
        show={showModal}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
}

AttachmentControls.propTypes = {
  attachmentsArchivePath: PropTypes.string.isRequired,
  copyAttachments: PropTypes.func.isRequired,
  parentDeal: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  loading: state.deal.loading,
  parentDeal: state.parentDeal || {},
});

const mapDispatchToProps = {
  copyAttachments,
};

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentControls);
